import * as actionTypes from "./types";

import documentService from "../services/document.service";

export const documentActions = {
  uploadFile,
  deleteFile,
  getFiles,
  resetFiles,
  uploadFileForRenewal,
  getRenewalFiles,
  deleteRenewalFile,
  clearRenewalFiles
};

function deleteFile(quoteId, fileId) {
  return dispatch => {
    return dispatch({
      type: actionTypes.DOCUMENT_DELETE,
      payload: documentService.deleteFile(quoteId, fileId)
    }).then(() => dispatch(getFiles(quoteId)));
  };
}

function deleteRenewalFile(policyId, fileId) {
  return dispatch => {
    return dispatch({
      type: actionTypes.RENEWAL_DOCUMENT_DELETE,
      payload: documentService.deleteRenewalFile(policyId, fileId)
    }).then(() => dispatch(getRenewalFiles(policyId)));
  };
}

function uploadFile(quoteId, actionType, fileType, file) {
  return dispatch => {
    return dispatch({
      type: actionType,
      payload: documentService.upload(quoteId, fileType, file)
    }).then(
      resp => {
        return dispatch(getFiles(quoteId));
      },
      error => {
        dispatch({ type: `${actionType}_REJECTED`, payload: error });
        return Promise.reject(error);
      }
    );
  };
}

function uploadFileForRenewal(policyId, actionType, fileType, file) {
  return dispatch => {
    return dispatch({
      type: actionType,
      payload: documentService.uploadForRenewal(policyId, fileType, file)
    }).then(
      resp => {
        return dispatch(getRenewalFiles(policyId));
      },
      error => {
        dispatch({ type: `${actionType}_REJECTED`, payload: error });
        return Promise.reject(error);
      }
    );
  };
}

function getFiles(quoteId) {
  return {
    type: actionTypes.DOCUMENT_ALL_GET,
    payload: documentService.getAllFilesByQuoteId(quoteId)
  };
}

function getRenewalFiles(policyId) {
  return {
    type: actionTypes.RENEWAL_DOCUMENT_ALL_GET,
    payload: documentService.getAllRenewalFilesByPolicyId(policyId)
  };
}

function clearRenewalFiles() {
  return {
    type: actionTypes.RENEWAL_DOCUMENT_RESET
  };
}

function resetFiles() {
  return {
    type: actionTypes.DOCUMENT_RESET
  };
}
